import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Button, IconButton, Input } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { headStyle, cardStyle, hrStyle, buttonStyle, headStyleInverted, backgroundStyle, lightColor, verticalCenter } from '../../css/styling';

function APIs() {
    return <>Under Development</>
}

export default APIs;